<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训资源开放预约</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">

        <el-form-item label="申请状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择申请状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="training_room_name" :label="`${$store.state.themeTitle}室`" width="120">
        </custom-table-column>
        <custom-table-column prop="status" label="申请状态" width="160" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="order_start" label="开始时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="order_end" label="结束时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="reason" label="申请理由" min-width="220px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">详情</el-button>
            <el-button @click="handleCancel(scope.row.id)" type="text" size="small">取消</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" style="width:532px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="order_start">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" v-model="ruleForm.order_start" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="order_end">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" v-model="ruleForm.order_end" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="申请理由" prop="reason">
          <el-input type="textarea" v-model="ruleForm.reason" placeholder="请输入申请理由" style="width:532px;" :rows="5"></el-input>
        </el-form-item>

        <div style="background:#edf4ff;padding:32px 0;width:100%;border-radius: 6px;">
          <div v-for="(item,index) in ruleForm.items" :key="index" style="width:100%;border: 3px solid #3176db;padding: 30px 0;box-sizing: border-box;border-radius: 15px;margin-bottom:4px;">
            <el-form :model="item" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
              <el-form-item label="设备名称" prop="id">
                <el-select v-model="item.id" style="width:216px;" filterable :placeholder="`请先选择${$store.state.themeTitle}室`" @change="handleEqChange(...arguments,index)">
                  <el-option v-for="eq in eqs" :key="eq.device_id" :label="eq.device_name" :value="eq.device_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数  量" prop="num">
                <el-input-number v-model="item.num" :min="0" :max="item.maxNum" label="请输入数量"></el-input-number>
              </el-form-item>
            </el-form>
            <div style="margin-top:12px;text-align:center;">
              <el-button type="danger" @click="handleItemDelete(item,index)" size="mini">删除</el-button>
            </div>
          </div>
          <div style="margin-top:12px;text-align:center;">
            <el-button size="mini" @click="handleItemAdd(0)">申请设备+</el-button>
          </div>
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="申请详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="2"  border>
        <el-descriptions-item>
          <template slot="label">{{$store.state.themeTitle}}室 </template> {{rowObj.training_room_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请状态 </template> 
          <span v-if="rowObj.status=='apply'" style="color:var(--blue);">待审核</span>
          <span v-if="rowObj.status=='pass'" style="color:var(--ligtGreen);">已通过</span>
          <span v-if="rowObj.status=='refuse'" style="color:var(--red);">已拒绝</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">开始时间 </template> {{rowObj.order_start}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">结束时间 </template> {{rowObj.order_end}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请理由 </template> {{rowObj.reason}}
        </el-descriptions-item>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">申请清单</p>
      <el-descriptions class="margin-top" title="" style="margin-bottom:16px;" v-for="(item,index) in listArr" :key="index" direction="vertical" :column="2"  border>
        <el-descriptions-item>
          <template slot="label">名 称 </template> {{item.item_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">数 量 </template> {{item.item_num}}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList,mixinFormatter],
  data() {
    return {
      formInline: {
        status: '',
      },
      detailDialogVisible: false,
      eqs: [],
      rowObj: [],
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        training_room_id: '',
        order_start: '',
        order_end: '',
        reason: '',
        items: [],
      },
      listArr:[],
      remainder_quantity: 0,
      rules: {
        training_room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        order_start: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        order_end: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        reason: [{ required: true, message: '申请理由不能为空', trigger: 'blur' }],
      },
      rules1: {},
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  methods: {
    handleLogChange(e) {
      this.ruleForm.scrap_name = this.$until.getLabelName(this.scraps, 'isid', 'ismc', e);
    },
    handleEqChange(val, index) {
      this.ruleForm.items[index].name = this.$until.getLabelName(this.eqs, 'device_id', 'device_name', val);
      this.ruleForm.items[index].maxNum = this.$until.getLabelName(this.eqs, 'device_id', 'count', val);
      this.ruleForm.items[index].num = 0
    },
    handleDetailClick(row) {
      this.rowObj = row;
      this.listArr = row.items;
      this.detailDialogVisible = true;
    },
    handleItemDelete(item, index) {
      this.ruleForm.items.splice(index, 1);
    },
    handleItemAdd(type) {
      this.ruleForm.items.push({ type, id: '', name: '', num: 0, maxNum: 0 });
    },
    handleCancel(id) {
      this.confirmBox('warning', `此操作将取消该预约申请，是否继续`, { id }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/open_reservation/apply/cancel/${params.id}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '取消成功！',
        });
        this.getList();
      }
    },
    async handleClassChange(e) {
      // this.$store.dispatch('getEqs')
      this.ruleForm.items = []
      if (this.ruleForm.training_room_id) {
        let params = { training_room_id: this.ruleForm.training_room_id };
        let res = await this.$api.instance.interfaceServer('api/new_device/count/by-training-room', 'get', params);
        if (res.code == 0 && res.data) {
          this.eqs = res.data;
        }
      } else {
        this.eqs = [];
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceScrap(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.items = params.items.map((item) => {
        return {
          type: item.type,
          name: item.name,
          num: item.num,
          id: item.id,
        };
      });
      params.items = JSON.stringify(params.items);
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // async updateJournalOfTearcher() {
    //   let params = this.$until.easyDeepCopy(this.ruleForm);;
    //   let res = await this.$api.update.updateJournalOfTearcher(params);
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '编辑成功！',
    //     });
    //     this.clearState();
    //   }
    // },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/listMy', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
